import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/bc4a7625-7c7a-4fff-b2c3-e5e04d3a44af";
export const REGISTER_URL = "https://a.ntrk2.com/32b0e9cd-6e9b-43b6-aec7-9b3023e01a3d";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bt268.loadprkw2a.com/download?openExternalBrowser=1&id=flw4v2q5z70iafy";

export * from "./codes";
export * from "./context";
